import { render, staticRenderFns } from "./NavigationDrawerSwitch.vue?vue&type=template&id=0d3612bb"
import script from "./NavigationDrawerSwitch.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawerSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports